import request from '@/utils/request'

export const getTicketInfo = (data) => {
  return request({
    url: '/data/wlist/get-trade-pro-info',
    method: 'post',
    data
  })
}

export const subEval = (data) => {
  return request({
    url: '/data/wlist/assess',
    method: 'post',
    data
  })
}

export const getGoodsBack = (data) => {
  return request({
    url: '/data/wlist/get-base-info',
    method: 'post',
    data
  })
}
